// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export {};

throw new Error(
  'The react.js entry point has moved. Please update your ESLint configuration to reference' +
    ' "@rushstack/eslint-config/mixins/react" instead.' +
    '\n\nSee the documentation for details: https://www.npmjs.com/package/@rushstack/eslint-config'
);
